import React, { useCallback } from "react";
import T from "prop-types";
import cn from "classnames";

import { Icons } from "2g-icons";

import { useServerMessage } from "b2b/i18n";
import { DateAktivita } from "b2b/renderers";
import { Uzivatel } from "b2b/renderers/ciselnik";

export function NotifikaceItem({ notifikace, onClick, onRead, onDelete }) {
  const serverMessage = useServerMessage();
  const handlleClick = useCallback(() => {
    onClick(notifikace);
  }, [onClick]);
  const handlleRead = useCallback(
    e => {
      e.stopPropagation();
      onRead(notifikace);
    },
    [onRead]
  );
  const handlleDelete = useCallback(
    e => {
      e.stopPropagation();
      onDelete(notifikace);
    },
    [onDelete]
  );

  return (
    <div
      className={cn("b2b-Notifikace", { "is-prectena": notifikace.prectena })}
    >
      <div onClick={handlleClick}>
        <div className="b2b-Notifikace-label">
          {serverMessage(notifikace, "hlavicka")}
        </div>
        <div className="b2b-Notifikace-info">
          <span className="b2b-Notifikace-infoDate">
            <DateAktivita val={notifikace.datumVytvoril} />
          </span>
          <span className="b2b-Notifikace-infoUser">
            <Uzivatel val={notifikace.uzivatel} />
          </span>
        </div>
        <div className="b2b-Notifikace-obsah">
          {serverMessage(notifikace, "obsah")}
        </div>
      </div>
      <div className="b2b-Notifikace-actions">
        <span className="b2b-Notifikace-actionsRead">
          <Icons.Check onClick={handlleRead} />
        </span>
        <span className="b2b-Notifikace-actionsDelete">
          <Icons.Close onClick={handlleDelete} />
        </span>
      </div>
    </div>
  );
}

NotifikaceItem.propTypes = {
  notifikace: T.object,
  onClick: T.func,
  onRead: T.func,
  onDelete: T.func
};

export default React.memo(NotifikaceItem);
